// extracted by mini-css-extract-plugin
export default {"main":"SettingsPage_main__WXfEO","content":"SettingsPage_content__TR6yN"};